var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIWatchBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9992 13.9535C12.3195 13.9535 14.2005 12.0725 14.2005 9.75213C14.2005 7.43179 12.3195 5.55078 9.9992 5.55078C7.67886 5.55078 5.79785 7.43179 5.79785 9.75213C5.79785 12.0725 7.67886 13.9535 9.9992 13.9535Z",
    stroke: "#1065D9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 12.752C11.6559 12.752 12.999 11.4088 12.999 9.75195C12.999 8.0951 11.6559 6.75195 9.99902 6.75195C8.34217 6.75195 6.99902 8.0951 6.99902 9.75195C6.99902 11.4088 8.34217 12.752 9.99902 12.752Z",
    fill: "#1065D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99907 13.9518C9.29324 13.9518 8.62583 13.7741 8.04004 13.4668V16.1797C8.04004 16.7078 8.47218 17.14 9.00035 17.14H10.993C11.5212 17.14 11.9533 16.7078 11.9533 16.1797V13.4668C11.3675 13.7741 10.7049 13.9518 9.99426 13.9518H9.99907Z",
    fill: "#1065D9",
    stroke: "#1065D9",
    strokeWidth: 0.72023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99915 5.55019C10.705 5.55019 11.3724 5.72785 11.9582 6.03514V3.82164C11.9582 3.29347 11.526 2.86133 10.9979 2.86133H9.00523C8.47706 2.86133 8.04492 3.29347 8.04492 3.82164V6.03514C8.63071 5.72785 9.29332 5.55019 10.0039 5.55019H9.99915Z",
    fill: "#1065D9",
    stroke: "#1065D9",
    strokeWidth: 0.72023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIWatchBlue);
export default __webpack_public_path__ + "static/media/i_watch_blue.bce0ed49c908cf9ef23b08d07f8b7c46.svg";
export { ForwardRef as ReactComponent };